import React from 'react';
import Link from '../../Link/Link';
import styles from './LegalGroup.module.scss';

const LegalGroup = () => {
  return (
    <div className={`${styles.rootLegalGroup} d-none d-md-block`}>
      <div className={`container`}>
        <div className={`row col-12 ${styles.customRow}`}>
          <div className='col-sm-8 pull-left'>
            <ul className={`${styles.text} text-left list-unstyled`}>
              <li>Superintendencia del Servicios de Salud</li>
              <li>Organo Control de Obras Sociales y entidades de Medicina Prepaga</li>
              <li>
                0800-222-SALUD (72583) |
                <Link className={styles.link} to='http://www.sssalud.gov.ar'>
                  www.sssalud.gov.ar
                </Link>
                | RNEMP Nº 132
              </li>
            </ul>
          </div>
          <div className='col-sm-4 m-0 p-0'>
            <div className={`${styles.logos} ${styles.logos}`}>
              <img
                src={`${process.env.PUBLIC_URL}/images/footer/logo_verisign.png`}
                alt='Verisign'
                loading='lazy'
              />
              <img
                src={`${process.env.PUBLIC_URL}/images/footer/logo_ministerio_justicia.png`}
                alt='Ministerio de Justicia'
                loading='lazy'
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalGroup;
